var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _circle, _circle2, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDataNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 144,
    viewBox: "0 0 221 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 143.28C0 143.28 26.26 98.68 109.21 98.68C196.98 98.68 220.61 143.28 220.61 143.28H0Z",
    fill: "url(#paint0_linear_9946_212432)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.6201,
    width: 67.38,
    height: 132.96,
    rx: 8.46,
    fill: "url(#paint1_linear_9946_212432)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 5.5H123.3C122.26 5.5 121.416 6.34 121.41 7.38V7.48C121.41 8.518 120.568 9.36 119.53 9.36H101.08C100.042 9.36 99.2002 8.518 99.2002 7.48V7.38C99.1942 6.34 98.3502 5.5 97.3102 5.5H89.2202C85.6212 5.494 82.6972 8.401 82.6802 12V119.89C82.6772 121.626 83.3652 123.292 84.5922 124.52C85.8192 125.75 87.4842 126.44 89.2202 126.44H131.4C133.136 126.44 134.801 125.75 136.028 124.52C137.255 123.292 137.943 121.626 137.94 119.89V12C137.918 8.404 134.996 5.5 131.4 5.5Z",
    fill: "url(#paint2_linear_9946_212432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9202 32.23C44.9202 29.176 42.4442 26.7 39.3902 26.7C38.8692 26.702 38.3502 26.776 37.8502 26.92C36.7642 22.928 32.9892 20.276 28.8652 20.606C24.7412 20.936 21.4372 24.156 21.0002 28.27C20.3952 28.045 19.7552 27.93 19.1102 27.93C16.3502 27.933 14.0142 29.967 13.6302 32.7V32.77C13.6252 32.847 13.6252 32.923 13.6302 33V33.48C13.6302 36.51 16.0702 38.973 19.1002 39H39.0002C40.7602 39.002 42.4202 38.19 43.5002 36.8C44.5872 35.54 45.1002 33.884 44.9202 32.23Z",
    fill: "url(#paint3_linear_9946_212432)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.44 47.05C200.443 45.31 199.626 43.67 198.235 42.622C196.845 41.576 195.042 41.245 193.37 41.73C192.294 37.725 188.512 35.058 184.378 35.39C180.244 35.72 176.935 38.955 176.51 43.08C175.905 42.855 175.265 42.74 174.62 42.74C171.86 42.743 169.524 44.777 169.14 47.51V47.58C169.135 47.657 169.135 47.733 169.14 47.81V48.29C169.14 49.757 169.724 51.165 170.764 52.2C171.804 53.236 173.213 53.815 174.68 53.81H194.55C196.31 53.812 197.97 53 199.05 51.61C200.123 50.347 200.626 48.697 200.44 47.05Z",
    fill: "url(#paint4_linear_9946_212432)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.08 107.72C52.08 107.72 46.88 109.34 45.84 101.48C44.91 94.48 50.26 89.48 50.26 89.48C50.26 89.48 56.26 93.06 57.26 99.56C58.13 105.64 56.5 107.2 52.08 107.72Z",
    fill: "url(#paint5_linear_9946_212432)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6299 107.82C52.6299 107.82 51.6299 108.52 51.0999 105.65C50.8269 104.134 50.9969 102.572 51.5899 101.15C52.5579 102.118 53.1949 103.368 53.4099 104.72C53.8199 106.93 53.5399 107.53 52.6299 107.82Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.49 114.44C183.49 114.44 187.16 116.38 189.04 110.63C190.72 105.48 187.39 101.03 187.39 101.03C187.39 101.03 182.39 102.89 180.77 107.62C179.24 112 180.24 113.43 183.49 114.44Z",
    fill: "url(#paint6_linear_9946_212432)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.06 114.44C183.06 114.44 183.74 115.11 184.52 113.02C184.942 111.924 185.032 110.727 184.78 109.58C183.92 110.172 183.265 111.018 182.91 112C182.3 113.6 182.42 114.1 183.06 114.44Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.482 79.9688L145.814 76.0551L154.236 83.2247L150.904 87.1385L142.482 79.9688Z",
    fill: "url(#paint7_linear_9946_212432)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.39,
    y: 86.6768,
    width: 10.31,
    height: 43.62,
    rx: 2.16,
    transform: "rotate(-49.59 146.39 86.6768)",
    fill: "url(#paint8_linear_9946_212432)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.4,
    cy: 63.74,
    r: 24.61,
    fill: "url(#paint9_linear_9946_212432)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.4,
    cy: 63.74,
    r: 19.16,
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M127.4 77.88C125.93 77.88 124.74 76.69 124.74 75.22C124.74 73.75 125.93 72.56 127.4 72.56C128.87 72.56 130.06 73.75 130.06 75.22C130.06 76.69 128.87 77.88 127.4 77.88Z",
    fill: "url(#paint10_linear_9946_212432)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 70.28H125.99L123.4 51.49H131.4L128.81 70.28Z",
    fill: "url(#paint11_linear_9946_212432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9946_212432",
    x1: 24.8605,
    y1: 99.8102,
    x2: 24.8605,
    y2: 134.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9946_212432",
    x1: 49.3035,
    y1: 61.281,
    x2: 149.559,
    y2: 119.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9946_212432",
    x1: 72.626,
    y1: 41.3848,
    x2: 139.106,
    y2: 94.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9946_212432",
    x1: 13.9556,
    y1: 27.2201,
    x2: 13.9556,
    y2: 45.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9946_212432",
    x1: 169.491,
    y1: 42.0303,
    x2: 169.491,
    y2: 60.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9946_212432",
    x1: 42.0551,
    y1: 86.9477,
    x2: 49.5783,
    y2: 107.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9946_212432",
    x1: 184.245,
    y1: 93.4626,
    x2: 174.723,
    y2: 106.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9946_212432",
    x1: 143.934,
    y1: 81.9067,
    x2: 153.199,
    y2: 81.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9946_212432",
    x1: 141.164,
    y1: 112.3,
    x2: 158.806,
    y2: 115.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F95A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9946_212432",
    x1: 100.105,
    y1: 80.8516,
    x2: 144.402,
    y2: 90.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F95A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9946_212432",
    x1: 109.485,
    y1: 55.73,
    x2: 115.765,
    y2: 79.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F95A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9946_212432",
    x1: 121.093,
    y1: 58.7352,
    x2: 136.566,
    y2: 69.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F95A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataNotFound);
export default __webpack_public_path__ + "static/media/ic_data_not_found.8434276cd258f138964d571eb2b8b598.svg";
export { ForwardRef as ReactComponent };